const PDP_CTA_ENGAGED_KEY = "pdpAppBottomSheetCtaEngaged";
export const PDP_CTA_ENGAGED_EVENT = "pdp-cta-engaged";

/** Mark that the user engaged a property-page CTA — suppresses the app bottom sheet. */
export const markPdpCtaEngaged = (): void => {
  if (typeof window === "undefined") return;
  try {
    window.sessionStorage.setItem(PDP_CTA_ENGAGED_KEY, "true");
    window.dispatchEvent(new Event(PDP_CTA_ENGAGED_EVENT));
  } catch {
    // sessionStorage unavailable — ignore
  }
};

export const hasPdpCtaEngaged = (): boolean => {
  if (typeof window === "undefined") return false;
  try {
    return window.sessionStorage.getItem(PDP_CTA_ENGAGED_KEY) === "true";
  } catch {
    return false;
  }
};

export default markPdpCtaEngaged;
